export default function Segmented() {
  return {}
}
